// String values on purpose: the product RadioGroup emits strings and the challenge
// `productId` is kept as a Nullable<string> throughout the form.
export enum AchievementProductEnum {
    Casino = '1',
    Sport = '2',
    Payment = '3',
}

export enum AchievementPeriod {
    Day = 1,
    Week = 2,
    Month = 3,
    Year = 4,
}
